import { IBenefit, TextType } from "@app/models/storyblok/basic";

export const formatBenefits = (content: IBenefit<TextType>[]): string[] =>
  content.reduce((result, benefit) => {
    if (benefit?.title?.content?.[0].content?.[0].text) {
      return [...result, benefit?.title?.content?.[0].content?.[0].text];
    }

    return result;
  }, []);
